import { api } from "../../../config/axios/interceptor";

/** Credit packs (rate per pack, GST %, messages per pack) from Zoho. */
export async function getCreditPacks() {
  const response = await api.get("credits/packs");
  return response;
}

/** Opens a payment session for the chosen packs; returns the widget settings. */
export async function checkoutCredits(items) {
  const response = await api.post("credits/checkout", { items });
  return response;
}

/** Order status; the server asks Zoho while the order is still pending. */
export async function getCreditOrder(orderId) {
  const response = await api.get(`credits/orders/${orderId}`);
  return response;
}

export async function getCreditHistory() {
  const response = await api.get("credits/history");
  return response;
}

/** Tells the server the checkout widget finished so it can confirm with Zoho. */
export async function verifyCreditOrder(orderId, { paymentId, signature } = {}) {
  const response = await api.post(`credits/orders/${orderId}/verify`, {
    paymentId,
    signature,
  });
  return response;
}

/** Renewal options for this clinic's tier: Yearly and 3-Years, priced by Zoho. */
export async function getRenewalPlans() {
  const response = await api.get("credits/plans");
  return response;
}

/** Opens a payment session to renew the subscription. */
export async function checkoutPlan(term) {
  const response = await api.post("credits/plan-checkout", { term });
  return response;
}

/** Tell the server these low-credit notices were shown (once a day rule). */
export async function ackCreditAlerts(channels, subscription = false) {
  const response = await api.post("credits/alerts/ack", {
    channels,
    subscription,
  });
  return response;
}

/** The paid invoice as a PDF (Blob). 409 until the invoice has been issued. */
export async function downloadCreditInvoice(orderId) {
  const response = await api.get(`credits/orders/${orderId}/invoice`, {
    responseType: "blob",
  });
  return response.data;
}
